import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@store';
import { clearProductRiskItemState } from '../store/slices/products-form';
import {
  useLazyGetIndividualProductQuery,
  useCreateIndividualProductMutation,
  useUpdateIndividualProductMutation,
  useLazyGetProductsIndividualQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import ProductsForm from '../../partial/products/form';

const IndividualProductForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    individualClientsRisk: {
      products: {
        form: { item },
      },
    },
  } = useAppSelector((state) => state);

  const { productId } = useParams();
  const dispatch = useAppDispatch();

  const [getIndividualProduct, { isLoading, isFetching }] =
    useLazyGetIndividualProductQuery();
  const [createProduct, { isLoading: requestInProgress, isSuccess }] =
    useCreateIndividualProductMutation();
  const [
    updateProduct,
    { isLoading: updateInProgress, isSuccess: updateSuccess },
  ] = useUpdateIndividualProductMutation();

  const [getList] = useLazyGetProductsIndividualQuery();

  const getIndividualProductAction = useCallback(() => {
    getIndividualProduct(productId as string);
  }, [productId]);

  useEffect(() => {
    setPanelIsOpen(true);

    if (productId) {
      getIndividualProductAction();
    }

    return () => {
      dispatch(clearProductRiskItemState());
    };
  }, [dispatch, productId, getIndividualProductAction]);

  return (
    <ProductsForm
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      clientType={RiskScoreClientTypeEnum.INDIVIDUAL}
      getList={getList}
      updateProduct={updateProduct}
      createProduct={createProduct}
      isSuccess={isSuccess}
      item={item}
      isLoading={isLoading}
      requestInProgress={requestInProgress}
      updateSuccess={updateSuccess}
      updateInProgress={updateInProgress}
      isFetching={isFetching}
    />
  );
};

export default IndividualProductForm;
